export enum CompanyScale {
	EARLY_STAGE = 'earlyStage',
	SME = 'sme',
	SCALE_UP = 'scaleUp',
	CORPORATE = 'corporate',
	MULTINATIONAL = 'multinational'
}
